module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAANxJREFUaIHt2LFNwwAQhtEHoaGkzQppKFIwBWVWYDdmYYEskDZFBoAiQrKQKFDuzgX/18WST/dk2bFMSimllNL/bVM874BHnIrn/lol4IA9djgbQlQBXvGy+D2GqAJc8IyHxbERRCXgaAVE5T2wCqL6KTSOqAYwjOgAMIjoAjCE6AQwgOgG0Iy4v+XkP/bZMfSuY+iPtnhzfclb9o6PW4d3A1qXpxfQvjx9gJHl6QGMLU89YHR5agHjy1MHWGV56v7I9lZYnrpXiSOeXK8EQ8t39P1lIqWUUkopDfQF1WM/ZhGvawIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_list_next.png
// module id = 130
// module chunks = 1